import { Divider } from '@intersport-digital/react'
import CustomIconButton, { ICustomIconButton } from '../custom-icon-button.tsx'
import { Link } from '@remix-run/react'

const Footer: React.FC<{}> = () => {
	const followUsIcons: ICustomIconButton[] = [
		{ name: 'instagram', href: 'https://www.instagram.com/intersportsverige/' },
		{ name: 'youtube', href: 'https://www.youtube.com/user/INTERSPORTsweden/' },
		{
			name: 'facebook',
			href: 'https://sv-se.facebook.com/intersport.sverige/',
		},
		{
			name: 'linkedin',
			href: 'https://www.linkedin.com/company/intersport-sweden/',
		},
	]

	return (
		<footer className="footer container mt-6">
			<Divider size="bold" />
			<div className="my-8 flex">
				<div className="col-12 lg:col-4 flex flex-col gap-8">
					<div>
						<div className="footer-heading">Kontakta oss</div>
						<div className="footer-email">
							<Link
								to="mailto:kundservice@intersport.se"
								className="footer-email__link"
							>
								kundservice@intersport.se
							</Link>
						</div>
					</div>
					<div>
						<div className="footer-heading">Följ oss</div>
						<div className="flex flex-wrap">
							{followUsIcons.map(icon => (
								<CustomIconButton key={icon.name} {...icon} />
							))}
						</div>
					</div>
				</div>
			</div>
			<Divider size="thin" />
			<div className="text-desc fw-medium my-5">
				© 2023 Intersport AB. Alla rättigheter förbehållna
			</div>
		</footer>
	)
}

export { Footer }
